import "./style.css";
import { initAnalytics } from "./analytics";
import { initBenchmark } from "./bench";

initAnalytics();
initBenchmark();